/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsurancePayor
 */
export interface InsurancePayor {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the InsurancePayor interface.
 */
export function instanceOfInsurancePayor(value: object): value is InsurancePayor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InsurancePayorFromJSON(json: any): InsurancePayor {
    return InsurancePayorFromJSONTyped(json, false);
}

export function InsurancePayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsurancePayor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function InsurancePayorToJSON(json: any): InsurancePayor {
    return InsurancePayorToJSONTyped(json, false);
}

export function InsurancePayorToJSONTyped(value?: InsurancePayor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

